import script from "./BurtonVariantOption.vue?vue&type=script&setup=true&lang=js"
export * from "./BurtonVariantOption.vue?vue&type=script&setup=true&lang=js"

import "./BurtonVariantOption.vue?vue&type=style&index=0&id=a7c8f4cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7c8f4cc"]])

export default __exports__